/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

export const GTM_ID = 'google.tag.manager.container.id';
export const GTM_AUTH = 'google.tag.manager.auth';
export const GTM_PREVIEW = 'google.tag.manager.preview';
export const GA_VERSIONS = 'google.analytics.versions';
export const GA_VERSION_UA = 'UA';
export const GA_VERSION_GA4 = 'GA4';
export const PAGE_LOAD = 'pageLoad';
export const KEYWORD_SEARCH = 'keywordSearch';
export const NAVIGATION_CLICK = 'navigationClick';
export const FORM_COMPLETION = 'formCompletion';
export const PRODUCT_IMPRESSION = 'productImpression';
export const PRODUCT_CLICK = 'productClick';
export const PRODUCT_DETAIL = 'productDetail';
export const BANNER_VIEW = 'bannerView';
export const BANNER_CLICK = 'bannerClick';
export const COOKIE_DIALOG_ACCEPT = 'cookieDialogAccept';
export const VIEW_LOOK = 'viewLook';
export const LOGIN_LESS_BEGIN = 'login_begin';
export const LOGIN_LESS_METHOD = 'login_method';
export const LOGIN_LESS_SUBMIT = 'login';
export const ADD_TO_CART = 'addToCart';
export const REMOVE_FROM_CART = 'removeFromCart';
export const PROMO_VIEW = 'promoView';
export const PROMOTION_CLICK = 'promotionClick';
export const PURCHASE = 'purchase';
export const CHECK_OUT = 'checkout';
export const CHECK_OUT_OPTION = 'checkoutOption';
export const HOME = 'Home';
export const ONSITE_SEARCH = 'Onsite Search';
export const LISTER = 'Lister';
export const PDP = 'PDP';
export const CHECKOUT = 'Checkout';
export const CONTENT = 'Content';
export const CART = 'Cart';
export const SIGN_UP = 'sign_up';
export const LOGIN_OPEN_LOGIN = 'login';
export const LOGIN_OPEN_REGISTER = 'register';
export const REGISTER_BEGIN = 'register_begin';
export const PASSWORD_RECOVERY_BEGIN = 'password_recovery_begin';
export const PASSWORD_RECOVERY_COMPLETE = 'password_recovery_complete';
export const DISABLED_ESPOT_LIST = ['HeaderStoreLogo', 'FooterStoreLogo'];
export const GA4_EVENT_ADD_TO_CART = 'add_to_cart';
export const GA4_EVENT_REMOVE_FROM_CART = 'remove_from_cart';
export const GA4_EVENT_BEGIN_CHECKOUT = 'begin_checkout';
export const GA4_EVENT_ADD_PAYMENT_INFO = 'add_payment_info';
export const GA4_EVENT_ADD_SHIPPING_INFO = 'add_shipping_info';
export const GA4_EVENT_PURCHASE = 'purchase';
export const GA4_EVENT_VIEW_CART = 'view_cart';
export const GA4_EVENT_VIEW_PROMOTION = 'view_promotion';
export const GA4_EVENT_SELECT_PROMOTION = 'select_promotion';
export const GA4_EVENT_VIEW_ITEM_LIST = 'view_item_list';
export const GA4_EVENT_SELECT_ITEM = 'select_item';
export const GA4_EVENT_SEARCH = 'search';
export const GA4_EVENT_VIEW_SEARCH_RESULTS = 'view_search_results';
export const GA4_EVENT_SEARCH_TYPE_PRODUCT = 'product';
export const GA4_EVENT_VIEW_ITEM = 'view_item';
export const GA4_EVENT_VIEW_BANNER = 'banner_view';
export const GA4_EVENT_CLICK_BANNER = 'banner_click';
export const GA4_EVENT_COOKIE_DIALOG_ACCEPT = 'consent';
export const GA4_EVENT_VIEW_LOOK = 'view_look';
export const GA4_EVENT_LOGIN_LESS_BEGIN = 'login_begin';
export const GA4_EVENT_LOGIN_LESS_METHOD = 'login_method';
export const GA4_EVENT_LOGIN_LESS_SUBMIT = 'login';
export const GA4_EVENT_LOGIN_OPEN_LOGIN = 'login';
export const GA4_EVENT_LOGIN_OPEN_REGISTER = 'register';
export const GA4_EVENT_REGISTER_BEGIN = 'register_begin';
export const GA4_EVENT_PASSWORD_RECOVERY_BEGIN = 'password_recovery_begin';
export const GA4_EVENT_PASSWORD_RECOVERY_COMPLETE = 'password_recovery_complete';
export const GA4_EVENT_SIGN_UP = 'sign_up';
export const PAGE_DATA_LAYER = 'PageDataLayer';
export const CHUNK_SIZE = 20;
export const LOGGED_IN = 'logged In';
export const LOGGED_OUT = 'logged Out';
export const ACTIVITY_PRODUCT = 'product';
export const ACTIVITY_CATEGORY = 'category';
export const ACTIVITY_CONTENT = 'content';
